import { de } from 'date-fns/locale';
const dateDeDE = {
  name: 'de-DE',
  locale: de
};
export default dateDeDE;